import axiosClient from "../../../../../../api/axiosClient";

const poLookupService = {
  searchByVendor: async (vendorId, search) => {
    if (!vendorId) return [];

    const res = await axiosClient.get(
      `/api/ppe/material-flow/purchase-order/grn-lookup?vendor_id=${vendorId}&search=${encodeURIComponent(search || "")}`
    );

    return res.data || [];
  },
};

export default poLookupService; 